<mat-toolbar color="primary">
  <mat-toolbar-row>
    <a mat-icon-button [routerLink]="homeLink" [routerLinkActive]="'false'">
      <mat-icon>home</mat-icon>
    </a>
    <practice-switcher></practice-switcher>
    <span class="toolbar-spacer"></span>
    @if (hasPractices) {
      <app-patient-search></app-patient-search>
    }
    <span class="toolbar-spacer"></span>

    @if (hasPractices && (isHandset$ || isTablet$ | async)) {
      <button mat-icon-button (click)="openSearch()">
        <mat-icon>search</mat-icon>
      </button>
    }

    <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
      @if (!hasNotifications) {
        <mat-icon>notifications_none</mat-icon>
      }
      @if (hasNotifications) {
        <mat-icon>notifications</mat-icon>
      }
    </button>
    <mat-menu #notificationMenu="matMenu">
      <notifications-menu></notifications-menu>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="appMenu">
      <mat-icon>apps</mat-icon>
    </button>
    <mat-menu #appMenu="matMenu" class="mat-menu-full-width">
      <app-menu></app-menu>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="userMenu">
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <user-menu></user-menu>
    </mat-menu>
  </mat-toolbar-row>
  @if (hasTabs) {
    <mat-toolbar-row style="height: 48px; padding: 0;">
      <ui-tab-bar></ui-tab-bar>
    </mat-toolbar-row>
  }
</mat-toolbar>
